import React from 'react';

const WarningIcon: React.FC<React.PropsWithChildren<unknown>> = props => (
  <svg
    width='200'
    height='200'
    viewBox='0 0 200 200'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect width='200' height='200' rx='100' fill='url(#paint0_linear_164_1460)' />
    <path
      opacity='0.4'
      d='M140.667 116.333L114 68.3334C110.417 61.875 105.458 58.3334 100 58.3334C94.5417 58.3334 89.5834 61.875 86 68.3334L59.3334 116.333C55.9584 122.458 55.5834 128.333 58.2917 132.958C61 137.583 66.3334 140.125 73.3334 140.125H126.667C133.667 140.125 139 137.583 141.708 132.958C144.417 128.333 144.042 122.417 140.667 116.333Z'
      fill='#A5A7AF'
    />
    <path
      d='M100 111.458C98.2918 111.458 96.8751 110.042 96.8751 108.333V87.5C96.8751 85.7917 98.2918 84.375 100 84.375C101.708 84.375 103.125 85.7917 103.125 87.5V108.333C103.125 110.042 101.708 111.458 100 111.458Z'
      fill='#A5A7AF'
    />
    <path
      d='M100 125C99.7501 125 99.4584 124.959 99.1668 124.917C98.9168 124.875 98.6668 124.792 98.4168 124.667C98.1668 124.584 97.9168 124.459 97.6668 124.292C97.4584 124.125 97.2501 123.959 97.0418 123.792C96.2918 123 95.8334 121.917 95.8334 120.834C95.8334 119.75 96.2918 118.667 97.0418 117.875C97.2501 117.709 97.4584 117.542 97.6668 117.375C97.9168 117.209 98.1668 117.084 98.4168 117C98.6668 116.875 98.9168 116.792 99.1668 116.75C99.7084 116.625 100.292 116.625 100.792 116.75C101.083 116.792 101.333 116.875 101.583 117C101.833 117.084 102.083 117.209 102.333 117.375C102.542 117.542 102.75 117.709 102.958 117.875C103.708 118.667 104.167 119.75 104.167 120.834C104.167 121.917 103.708 123 102.958 123.792C102.75 123.959 102.542 124.125 102.333 124.292C102.083 124.459 101.833 124.584 101.583 124.667C101.333 124.792 101.083 124.875 100.792 124.917C100.542 124.959 100.25 125 100 125Z'
      fill='#A5A7AF'
    />
    <defs>
      <linearGradient
        id='paint0_linear_164_1460'
        x1='36.5854'
        y1='185.366'
        x2='185.366'
        y2='31.7073'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F2F7FB' />
        <stop offset='1' stopColor='#EAEDF5' stopOpacity='0' />
      </linearGradient>
    </defs>
  </svg>
);

export default WarningIcon;
